var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ma-4 invoice-table-shell portal-compact-list-shell" },
    [
      _c(
        "div",
        { staticClass: "mt-4" },
        [
          _c("v-data-table", {
            staticClass: "portal-compact-table",
            staticStyle: { cursor: "pointer" },
            attrs: {
              headers: _vm.headers,
              items: _vm.filteredResults,
              "sort-by": "dateSent",
              "sort-desc": true,
              "hide-default-footer": true,
              "disable-pagination": true,
              "mobile-breakpoint": 200
            },
            on: {
              "click:row": function($event) {
                return _vm.openInvoice($event)
              }
            },
            scopedSlots: _vm._u([
              {
                key: "item.dateSent",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    item.dateSent
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "portal-cell-truncate portal-cell-muted",
                            attrs: {
                              title: _vm.DateTime.fromISO(
                                item.dateSent
                              ).toLocaleString(_vm.DateTime.DATE_MED)
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.DateTime.fromISO(
                                    item.dateSent
                                  ).toLocaleString(_vm.DateTime.DATE_MED)
                                ) +
                                " "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "item.dateDue",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    item.dateDue
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "portal-cell-truncate portal-cell-muted",
                            attrs: {
                              title: _vm.DateTime.fromISO(
                                item.dateDue
                              ).toLocaleString(_vm.DateTime.DATE_MED)
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.DateTime.fromISO(
                                    item.dateDue
                                  ).toLocaleString(_vm.DateTime.DATE_MED)
                                ) +
                                " "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "item.invoiceNumberFormatted",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "portal-cell-truncate portal-cell-primary",
                        attrs: { title: item.invoiceNumberFormatted }
                      },
                      [_vm._v(" " + _vm._s(item.invoiceNumberFormatted) + " ")]
                    )
                  ]
                }
              },
              {
                key: "item.total",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    item.total
                      ? _c("div", { staticClass: "portal-cell-truncate" }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$formatters.dollars(
                                  item.total ? item.total : 0,
                                  true,
                                  true,
                                  item.currency
                                )
                              )
                            )
                          ]),
                          item.refundTotal
                            ? _c(
                                "div",
                                { staticClass: "font-11 portal-cell-muted" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("invoices.refunded-amount", {
                                          amount: _vm.$formatters.dollars(
                                            item.refundTotal,
                                            true,
                                            true,
                                            item.currency
                                          )
                                        })
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ]
                }
              },
              {
                key: "item.status",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "portal-status-pill",
                      {
                        attrs: {
                          color: "var(" + item.statusDetail.color + ")",
                          background:
                            "var(" + item.statusDetail.background + ")"
                        }
                      },
                      [_vm._v(" " + _vm._s(item.statusDetail.label) + " ")]
                    )
                  ]
                }
              },
              {
                key: "item.id",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    item.statusDetail.payable &&
                    item.amountDue > 0 &&
                    item.payOnlineUrl &&
                    item.allowOnlinePayment
                      ? _c(
                          "v-btn",
                          {
                            attrs: {
                              elevation: "0",
                              color: "success",
                              small: ""
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.goToPaymentPage(item.payOnlineUrl)
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "font-12 brand-bold" }, [
                              _vm._v(_vm._s(_vm.$t("invoices.pay-now")))
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "no-data",
                fn: function() {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.$t("invoices.no-invoice-record")) + " "
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }